import { Component, Input, OnInit } from '@angular/core';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { NpFlexGridCtrl } from '../np-flex-grid-ctrl';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'np-flex-grid-selector2',
  standalone: true,
  imports: [CommonModule, WjGridModule],
  templateUrl: './np-flex-grid-selector2.component.html',
  styleUrl: './np-flex-grid-selector2.component.scss'
})
export class NpFlexGridSelector2Component implements OnInit {

  @Input() flexGridCtrl!: NpFlexGridCtrl;
  @Input() useCheckbox: boolean = false;
  @Input() columnGroup: boolean = false;

  ngOnInit(): void {
  }

}
